/** No screen at that address. Kept separate so the router's own fallback has no dependencies. */

import { Link } from "@tanstack/react-router";

export function NotFoundScreen() {
  return (
    <div className="main">
      <div className="main__inner">
        <h1 className="page-title">Not found</h1>
        <p className="page-lede">There is no screen at that address.</p>
        <Link className="button-secondary" to="/knowledge">
          Go to Knowledge
        </Link>
      </div>
    </div>
  );
}
